module.exports = __webpack_public_path__ + "static/media/pan-toggle.900bd135.svg";